import type { FactoryOpts } from "imask";

type MaskTypeMap = Record<
    string,
    {
        mask: FactoryOpts["mask"];
        placeholder: string;
    }
>;

export const AVAILABLE_INPUT_MASKS = {
    phone: {
        mask: [
            {
                mask: "+0 (000) 000-00-00",
                overwrite: true,
            },
            {
                mask: "+00 (000) 000-00-00",
                overwrite: true,
            },
            {
                mask: "+000 (000) 000-00-00",
                overwrite: true,
            },
        ],
        placeholder: "+7 (000) 000-00-00",
    },
    date: {
        mask: Date,
        placeholder: "ДД.ММ.ГГГГ",
    },
} satisfies MaskTypeMap;

export type AvailableMasksTypeKeys = keyof typeof AVAILABLE_INPUT_MASKS;
export type AvailableMasksType =
    (typeof AVAILABLE_INPUT_MASKS)[AvailableMasksTypeKeys];

export const updateMaskPlaceholder = (
    placeholder: string,
    value: string,
): {
    value: string;
    placeholder: string;
} => {
    if (value.length >= placeholder.length) {
        return {
            value,
            placeholder: "",
        };
    }

    return {
        value,
        placeholder: placeholder.substring(value.length),
    };
};

export const getMask = (
    maskKey: AvailableMasksTypeKeys | undefined,
): null | AvailableMasksType => {
    if (!maskKey) {
        return null;
    }
    return AVAILABLE_INPUT_MASKS[maskKey];
};
